import type { Middleware } from '@reduxjs/toolkit';
import { api } from '@/shared/api';
import { writeCachedUser } from '@/features/auth';

/** Складывает свежий профиль на устройство — его читает экран профиля */
export const userCacheMiddleware: Middleware = () => (next) => (action) => {
  if (api.endpoints.getCurrentUser.matchFulfilled(action)) {
    writeCachedUser(action.payload);
  }

  return next(action);
};
